export default __webpack_public_path__ + "static/media/DarkModeLearnBackground.40978ea8.png";